<template>
  <div>
    <code>{{ shortCode }}</code>

    <ion-button 
      v-clipboard:copy="code"
      color="primary" 
      class="uuid-clipboard" 
      fill="outline"
      size="small"
    >
      <ion-icon
        :src="i.clipboardOutline"
        mode="ios"
      />
    </ion-button>
  </div>
</template>

<script>
export default {
  props: {
    code: {
      type: String,
      required: true
    },
    length: {
      type: Number,
      default: undefined
    }
  },
  computed: {
    shortCode() {
      if(this.length) {
        return this.code.substring(0, this.length) + '...'
      }

      return this.code
    }
  }
}
</script>